import {
    GET_EMPLOYEE_INFO,
    SET_EMPLOYEE_INFO,
    SET_EMPLOYEE_ID_ERROR,
    SET_EMPLOYEE_REASON_INFO
} from "./EmployeeInfoType"

const getEmployeeInfo = (employeeInfo : any) => ({
    type: GET_EMPLOYEE_INFO,
    employeeInfo: employeeInfo
});

const setEmployeeInfo = (employeeInfo: any) => ({
    type: SET_EMPLOYEE_INFO,
    employeeInfo: employeeInfo
});

const setEmployeeReasonInfo = (reasonInfo: any) => ({
    type: SET_EMPLOYEE_REASON_INFO,
    reasonInfo: reasonInfo
});

const setEmployeeIDError = (error : any) => ({
    type: SET_EMPLOYEE_ID_ERROR,
    error
});

export {
    getEmployeeInfo,
    setEmployeeInfo,
    setEmployeeIDError,
    setEmployeeReasonInfo
}